<template>
    <div>

        <div class="adaptation-block">
            <div class="adaptation-block__double-column">
                <uzhnet-back-button @click="$router.go(-1)" />

                <div class="header-block location-center">
                    <div class="barrier">
                        <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M119 1H114L125 11H130L119 1Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M114 1H0" stroke="#CACACA"/>
                            </svg>
                    </div>
                    <div class="label">
                        {{ $t('selectTariffPage.header') }}
                    </div>
                    <div class="barrier">
                        <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 11H18L7 1H2L13 11Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M18 11H132" stroke="#CACACA"/>
                            </svg>
                    </div>
                </div>

                <div class="desktop-grid">
                    <div v-for="tariff in allTariffs.tariffs" @click="selectTariff(tariff)" class="tariff-panel">
                        <div class="tariff-panel__background">
                            <img src="@/assets/icons/specials/tariff-panel-background.svg" alt="">
                        </div>
                        <div class="multi-label">
                            <div class="text-panel">
                                <div class="text-panel__lt-angle">
                                    <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line x1="0.273566" y1="4.38855" x2="0.273566" y2="-2.14457e-05" stroke="#C7C8D1" stroke-width="0.548571"/>
                                        <line x1="0.547852" y1="0.27442" x2="4.38785" y2="0.27442" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    </svg>
                                </div>
                                <div class="text-panel__lb-angle">
                                    <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line x1="4.38855" y1="5.05749" x2="-2.14337e-05" y2="5.05749" stroke="#C7C8D1" stroke-width="0.548571"/>
                                        <line x1="0.274542" y1="4.7832" x2="0.274542" y2="0.943203" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    </svg>
                                </div>
                                <div class="text-panel__rb-angle">
                                    <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line x1="4.11413" y1="0.943481" x2="4.11413" y2="5.33205" stroke="#C7C8D1" stroke-width="0.548571"/>
                                        <line x1="3.83984" y1="5.05749" x2="-0.000156188" y2="5.05749" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    </svg>
                                </div>
                                <div class="text-panel__rt-angle">
                                    <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line y1="0.725714" x2="4.38857" y2="0.725714" stroke="#C7C8D1" stroke-width="0.548571"/>
                                        <line x1="4.11413" y1="1" x2="4.11413" y2="4.84" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    </svg>
                                </div>

                                <div class="text-panel__background">

                                </div>

                                <div class="text-panel__text">
                                    {{ tariff.name }}
                                </div>

                            </div>
                            <div class="text-panel">
                                <div class="text-panel__lt-angle">
                                    <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line x1="0.273566" y1="4.38855" x2="0.273566" y2="-2.14457e-05" stroke="#C7C8D1" stroke-width="0.548571"/>
                                        <line x1="0.547852" y1="0.27442" x2="4.38785" y2="0.27442" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    </svg>
                                </div>
                                <div class="text-panel__lb-angle">
                                    <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line x1="4.38855" y1="5.05749" x2="-2.14337e-05" y2="5.05749" stroke="#C7C8D1" stroke-width="0.548571"/>
                                        <line x1="0.274542" y1="4.7832" x2="0.274542" y2="0.943203" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    </svg>
                                </div>
                                <div class="text-panel__rb-angle">
                                    <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line x1="4.11413" y1="0.943481" x2="4.11413" y2="5.33205" stroke="#C7C8D1" stroke-width="0.548571"/>
                                        <line x1="3.83984" y1="5.05749" x2="-0.000156188" y2="5.05749" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    </svg>
                                </div>
                                <div class="text-panel__rt-angle">
                                    <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line y1="0.725714" x2="4.38857" y2="0.725714" stroke="#C7C8D1" stroke-width="0.548571"/>
                                        <line x1="4.11413" y1="1" x2="4.11413" y2="4.84" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    </svg>
                                </div>

                                <div class="text-panel__background">

                                </div>

                                <div class="text-panel__multi-text">
                                    <div v-if="store.tariffType === 'internet'">{{ tariff.id_down }} <span class="micro-text"> {{ $t('selectTariffPage.speed') }}</span></div>
                                    <div v-if="store.tariffType === 'tv'">{{ tariff.channels.length }} <span class="micro-text"> {{ $t('selectTariffPage.channels') }}</span></div>
                                    <div>{{ tariff.summa }} <span class="micro-text"> {{ $t('selectTariffPage.currency') }}/<span v-if="tariff.name !== 'Day'">{{ $t('selectTariffPage.priceMonth') }}</span><span v-else>{{ $t('selectTariffPage.priceDay') }}</span>
                                    </span></div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useMainStore } from '@/store/mainStore'
import ApiManager from '@/services/ApiManager'
import { calculateFingerprint } from '@/services/fingerprint'
import { decryptMessage } from '@/services/cryptoUtils';
import { getAccountByLogin, dropAllAccounts } from '@/db/accountService';

export default {
    name: "TariffList",

    setup() {
        const store = useMainStore()
        const router = useRouter()

        const fingerprint = ref('')
        const login = ref('')

        const allTariffs = ref([])

        onMounted(async () => {
            fingerprint.value = await calculateFingerprint()
            login.value = store.login

            const maybeAccount = await getAccountByLogin(login.value)
            let auth_token = ''
            try {
                auth_token = await decryptMessage(maybeAccount.token, fingerprint.value, maybeAccount.iv)
            } catch (error) {
                console.error('Unable to decrypt saved account:', error.message);
                await dropAllAccounts()
                router.push('/')
                return
            }

            if (store.tariffType === 'internet') {
                allTariffs.value = (await ApiManager.getInternetTariffs(auth_token)).data

                allTariffs.value.tariffs = allTariffs.value.tariffs.filter(tariff => tariff.name !== 'Bike')

                if (store.special_tariffs_available == '0') {
                    allTariffs.value.tariffs = allTariffs.value.tariffs.filter(tariff => tariff.name !== 'Rocket')
                }
            } else {
                allTariffs.value = (await ApiManager.getTvTariffs(auth_token)).data
            }
        })

        const selectTariff = async (tariff) => {
            store.setTariffObject(tariff)
            router.push('/selected-tariff')
        }

        return {
            store,
            allTariffs,
            selectTariff
        }
    }
}
</script>
<style lang="scss">
    .tariff-panel {
        & > .multi-label {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-38%, -50%);
            width: 100%;
        }

    }

    .text-panel {
        &__multi-text {
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #FFFFFF;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            margin-top: 2px;
            padding: 0 14px;
        }

    }

    .micro-text {
        font-size: 10px;
        font-weight: 200;
    }

    @media screen and (max-width: 350px) {
        .text-panel__multi-text {
            font-size: 14px;
        }

        .micro-text {
            font-size: 8px;
        }

    }

    @media screen and (max-width: 315px) {
        .text-panel__multi-text {
            font-size: 12px;
        }

        .micro-text {
            font-size: 6px;
        }

    }

    @media screen and (max-width: 330px) {
        .text-panel {
            height: 35px;
        }

        .text-panel__background {
            height: 17px;
        }

    }

    @media screen and (max-width: 295px) {
        .text-panel__multi-text {
            font-size: 12px;
        }

        .micro-text {
            font-size: 6px;
        }

    }

    @media screen and (max-width: 280px) {
        .text-panel__multi-text {
            font-size: 12px;
        }

        .micro-text {
            font-size: 6px;
        }

    }

    @media screen and (max-width: 260px) {
        .text-panel__multi-text {
            font-size: 12px;
        }

        .micro-text {
            font-size: 6px;
        }

    }
</style>
